import * as Types from '../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ProductPagesInsuranceFeesQueryVariables = Types.Exact<{
  deviceModel: Types.Scalars['String'];
}>;


export type ProductPagesInsuranceFeesQuery = { __typename?: 'query_root', insuranceFees: { __typename?: 'InsuranceFees', breakageFee: number, theftFee: number } };


export const ProductPagesInsuranceFeesDocument = gql`
    query productPagesInsuranceFees($deviceModel: String!) {
  insuranceFees: nest_customerGetInsuranceFees(deviceModel: $deviceModel) {
    breakageFee
    theftFee
  }
}
    `;
export function useProductPagesInsuranceFeesQuery(baseOptions: Apollo.QueryHookOptions<ProductPagesInsuranceFeesQuery, ProductPagesInsuranceFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPagesInsuranceFeesQuery, ProductPagesInsuranceFeesQueryVariables>(ProductPagesInsuranceFeesDocument, options);
      }
export function useProductPagesInsuranceFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPagesInsuranceFeesQuery, ProductPagesInsuranceFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPagesInsuranceFeesQuery, ProductPagesInsuranceFeesQueryVariables>(ProductPagesInsuranceFeesDocument, options);
        }
export type ProductPagesInsuranceFeesQueryHookResult = ReturnType<typeof useProductPagesInsuranceFeesQuery>;
export type ProductPagesInsuranceFeesLazyQueryHookResult = ReturnType<typeof useProductPagesInsuranceFeesLazyQuery>;
export type ProductPagesInsuranceFeesQueryResult = Apollo.QueryResult<ProductPagesInsuranceFeesQuery, ProductPagesInsuranceFeesQueryVariables>;